import React, { useEffect, useRef, useState } from 'react';
import CustomGrid from './CustomGrid';

interface GridContainerProps {
  layoutDefinition: any[];
  rowData: object[];
  [key: string]: any;
}

const GridContainer = ({ layoutDefinition, rowData, ...otherProps }: GridContainerProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(300);

  useEffect(() => {
    const updateHeight = () => {
      if (containerRef.current) {
        const containerHeight = containerRef.current.offsetHeight;
        // SubTitleLayout 높이(약 50px) 제외
        setHeight(Math.max(containerHeight - 50, 100));
      }
    };

    updateHeight();
    const resizeObserver = new ResizeObserver(updateHeight);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <div ref={containerRef} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CustomGrid
        layoutDefinition={layoutDefinition}
        rowData={rowData}
        height={height}
        {...otherProps}
      />
    </div>
  );
};

export default GridContainer;
